const makeItem = item => ({
  level: item.level,
  value: {
    coding: [
      {
        system: 'http://hl7.org/fhir/organization-type',
        display: item.definition,
        code: item.code
      }
    ],
    text: item.label
  },
  label: item.label
})

export default [
  {
    level: '1',
    code: 'prov',
    label: 'Healthcare Provider',
    definition: 'An organization that provides healthcare services.'
  },
  {
    level: '2',
    code: 'dept',
    label: 'Hospital Department',
    definition:
      'A department or ward within a hospital (Generally is not applicable to top level organizations)'
  },
  {
    level: '3',
    code: 'team',
    label: 'Organizational Team',
    definition:
      'An organizational team is usually a grouping of practitioners that perform a specific function within an organization (which could be a top level organization, or a department).'
  },
  {
    level: '4',
    code: 'govt',
    label: 'Government',
    definition:
      'A political body, often used when including organization records for government bodies such as a Federal Government, State or Local Government.'
  },
  {
    level: '4',
    code: 'ins',
    label: 'Insurance Company',
    definition:
      'A company that provides insurance to its subscribers that may include healthcare related policies.'
  },
  {
    level: '5',
    code: 'edu',
    label: 'Educational Institute',
    definition:
      'An educational institution that provides education or research facilities.'
  },
  {
    level: '6',
    code: 'reli',
    label: 'Religious Institution',
    definition:
      'An organization that is identified as a part of a religious institution.'
  },
  {
    level: '7',
    code: 'crs',
    label: 'Clinical Research Sponsor',
    definition:
      'An organization that is identified as a Pharmaceutical/Clinical Research Sponsor.'
  },
  {
    level: '8',
    code: 'cg',
    label: 'Clinical Group',
    definition: 'An un-incorporated community group.'
  },
  {
    level: '8',
    code: 'bus',
    label: 'Non-Healthcare Business or Corporation',
    definition:
      'An organization that is a registered business or corporation but not identified by other types.'
  },
  {
    level: '9',
    code: 'other',
    label: 'Other',
    definition: 'Other type of organization not already specified.'
  }
].map(v => makeItem(v))
